var map = {
	"./AccountCloser.vue": [
		416,
		80
	],
	"./CommodityPdf.vue": [
		3139,
		5340
	],
	"./CurrencyPdf.vue": [
		4955,
		8328
	],
	"./VerifyAddress.vue": [
		8499,
		6415,
		5093
	],
	"./VerifyBank.vue": [
		3314,
		6415,
		3216
	],
	"./VerifyDdpi.vue": [
		2100,
		4591
	],
	"./VerifyEmail.vue": [
		3544,
		471
	],
	"./VerifyMobile.vue": [
		2563,
		9640
	],
	"./VerifyNominee.vue": [
		2927,
		5634,
		897
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1029;
module.exports = webpackAsyncContext;